import React from "react";
import Card from "react-bootstrap/Card";
function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Mohamed Gamal</span>{" "}
            from <span className="purple">Egypt, Giza</span>.
            <br />
            I’m a{" "}
            <span className="purple">Front End Developer</span> 
            <br />
           Passionate about creating <span className="purple">responsive</span> web applications.
           <br />
           that leads to the <span className="purple">success</span>  of the overall product.
   <br />
          I am extremely passionate about  <span className="purple">web development;</span>  nothing brings me greater pleasure than turning ideas into reality.
   <br />
          I am dedicated to building lasting partnerships with my clients, consistently delivering and maintaining projects to the  <span className="purple">highest standards</span>   from  <span className="purple">start</span>   to  <span className="purple">finish.</span>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}
export default AboutCard;
